<template>
    <div>
        <v-dialog v-model="abrir" persistent max-width="1000px">
            <v-card>
                <v-card-title>
                <span class="headline">{{config.titulo}}</span>
                </v-card-title>
                <v-progress-linear v-if="cargando"
                    indeterminate
                    color="blue darken-2"
                ></v-progress-linear>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="nro_lote" label="N° Lote*"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-select
                            :items="antioxidante_nombre_opciones"
                            v-model="ant_nombre_id"
                            label="Nombre Antioxidante"
                            item-text="nombre"
                            item-value="id"
                            
                            class=""
                            ></v-select>
                        </v-col>
                        <v-col>
                            <date-picker type="datetime" :clearable="false" :confirme="true" v-model="fecha_lote" format="DD-MM-YYYY HH:mm" :default-value="fecha_lote" valueType="YYYY-MM-DD HH:mm"></date-picker>
                        </v-col>
                        <v-col>
                            <v-switch v-model="lote_cerrado" :label="`Lote Cerrado`"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card>
                                <v-simple-table>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="cabecera text-left">Tipo</th>
                                            <th class="cabecera text-left">Materia Prima</th>
                                            <th class="cabecera text-left">Antioxidante</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td>{{ tipo_lote }}</td>
                                        <td>{{ materia_prima }}</td>
                                        <td>{{ antioxidante }}</td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                    <!-- <pre>{{ant_nombre_id}}</pre>
                    <pre>{{antioxidante_nombres}}</pre> -->
                    <v-row>
                        <v-col>
                            <v-select
                            :items="tipo_lotes"
                            v-model="tp"
                            label="Tipo Lote"
                            item-text="tipo_lote"
                            item-value="id"
                            return-object
                            class="hidden"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-select
                            :items="materias_primas"
                            v-model="mp"
                            label="Materia Prima"
                            item-text="tipo_materia_prima"
                            item-value="id"
                            return-object
                            class="hidden"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-select
                            :items="antioxidantes"
                            v-model="ant"
                            label="Antioxidante"
                            item-text="nombre"
                            item-value="id"
                            return-object
                            class="hidden"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-card-text>
                            <alert></alert>
                        </v-card-text>
                    </v-row>
                </v-container>
                <small>*Campos Obligatorios</small>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" dark @click="abrir = false">Cerrar</v-btn>
                <v-btn color="green darken-1" dark @click="submit" :disabled="!validar">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Alert from '@/components/shared/Alert.vue';
import { mapState } from 'vuex';
export default {
    data:()=>({
        materias_primas:[],
        antioxidantes:[],
        antioxidante_nombres:[],
        tipo_lotes:[],
        config:{},
        nro_lote:'',
        fecha_lote:'',
        lote_cerrado:0,
        ant_nombre_id:null,
        abrir:false,
        lote:null,
        tp:null,
        mp:null,
        ant:null,
        cargando:false,
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_lotes');
    },
    mounted(){
        this.$parent.$on('abrir_modal_lotes',(config,lote)=>{
            console.log('lote',lote);
            this.config = config;
            this.materias_primas = config.materias_primas;
            this.antioxidantes = config.antioxidantes;
            this.antioxidante_nombres = config.antioxidante_nombres;
            this.tipo_lotes = config.tipo_lotes;
            /* if(this.tipo_lotes.length == 0){
                this.cargarTipoLotes();
            } */
            this.cargarTipoLotes();
            this.lote = lote;
            this.ant_nombre_id = this.lote? this.lote.anti_comerc_id:null;
            this.limpiar();
            if(this.lote){
                console.log('lote recibido',lote);
                this.nro_lote = this.lote.nombre_lote;
                this.fecha_lote = this.moment(this.lote.fecha_produccion).format('YYYY-MM-DD HH:mm');
                this.lote_cerrado = this.lote.cerrado;
            }
            this.abrir = true;
        })
    },
    methods:{
        obtener_tipo_lote(nombre_corto){
            let tipo_lote = this.tipo_lotes.find(function (tp){
                return tp.nombre_corto == nombre_corto;
            });
            return tipo_lote;
        },
        obtener_materia_prima(codigo){
            let materia_prima = this.materias_primas.find(function (mp){
                return mp.codigo == codigo;
            });
            return materia_prima;
        },
        obtener_antioxidante(codigo){
            let antioxidante = this.antioxidantes.find(function (ant){
                return ant.codigo == codigo;
            });
            return antioxidante;
        },
        async submit(){
            this.cargando = true;
            console.log('enviando peticion');
            let url = ``;
            let body = {
                fecha_produccion:this.fecha_lote,
                tipo_lotes_id : this.tp.id,
                nombre_lote: this.nro_lote,
                tipo_mps_id: this.mp.id,
                antioxidantes_id: this.ant.id,
                antioxidante_nombre_id:this.ant_nombre_id,
                cerrado: this.lote_cerrado
            }
            this.nro_lote = null;
            console.log('body',body);
            if(this.config.tipo_peticion == 'POST'){
                /**nuevo lote */
                url = `${this.base_url}lotes`;
                await this.axios.post(url,body,this.headers).then((res)=>{
                    if(res.data.message != "false"){
                        this.$emit('realizado');
                        this.abrir = false;
                    } else {
                        Event.$emit('mostrar_alert',{tipo: "success",mensaje: "Lote " + body.nombre_lote + " ya existe"});
                    }
                }).catch((error)=>{
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                })
            }else{
                /**actualización */
                url = `${this.base_url}lotes/${this.lote.id}`;
                await this.axios.put(url,body,this.headers).then((res)=>{
                    Event.$emit('mostrar_alert',{tipo: "success",mensaje: res.data.message});

                    this.$emit('realizado');
                    this.abrir = false;
                }).catch((error)=>{
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                })
            }
            this.cargando = false;
            this.nro_lote = body.nombre_lote;
        },
        limpiar(){
            this.nro_lote = '';
            this.fecha_lote = this.moment().format('YYYY-MM-DD HH:mm');
            this.lote_cerrado = 0;
            this.tp = null;
            this.mp = null;
            this.ant = null;
        },

        regexTest(string){
            let patt = new RegExp(/[^R\-0-9]+/g);
            let res = patt.test(string);
            return res;
        },

        async cargarTipoLotes(){
            this.cargando = true;
            let url = `${this.base_url}tipo_lote`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('Tipos de Lote',response);
                this.tipo_lotes = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.cargando = false;
            });
            this.cargarEspecies();
        },

        async cargarEspecies(){
            await this.axios.get(`${this.base_url}configuracion_mp/3/tipo_mps`,this.headers).then((response)=>{
                this.materias_primas = response.data.data;
                console.log('materias primas',response.data.data);
            }).catch((error)=>{
                console.log('error',error);
                this.cargando = false;
            });
            this.cargarAntioxidantes();
        },

        async cargarAntioxidantes(){
            await this.axios.get(`${this.base_url}antioxidantes`,this.headers).then((response)=>{
                this.antioxidantes = response.data.data;
                this.cargando = false;
                console.log('antioxidantes',response.data.data);
            }).catch((error)=>{
                console.log('error',error);
                this.cargando = false;
            });
            this.cargarAntioxidanteNombres();
        },

        async cargarAntioxidanteNombres(){
            await this.axios.get(`${this.base_url}antioxidante_nombres`,this.headers).then((response)=>{
                this.antioxidante_nombres = response.data.data;
                this.cargando = false;
                console.log('antioxidante_nombres',response.data.data);
            }).catch((error)=>{
                console.log('error',error);
                this.cargando = false;
            })
        },
    },
    computed:{
        materia_prima(){
            if(this.nro_lote){
                if(this.nro_lote.includes("R")){
                    /**lote repaso */
                    let codigo = this.nro_lote.charAt(2);
                    let mp = this.obtener_materia_prima(codigo);
                    this.mp = mp;
                    console.log('materia prima',mp);
                }else{
                    /**lote normal */
                    let codigo = this.nro_lote.charAt(0);
                    let mp = this.obtener_materia_prima(codigo);
                    this.mp = mp;
                    console.log('materia prima',mp);
                }
                return this.mp ? this.mp.tipo_materia_prima : '';
            }
            return '';
        },
        antioxidante(){
            if(this.nro_lote){
                if(this.nro_lote.includes("R")){
                    /**lote repaso */
                    let codigo = this.nro_lote.charAt(3);
                    let ant = this.obtener_antioxidante(codigo);
                    this.ant = ant;
                    console.log('antioxidante',ant);
                }else{
                    /**lote normal */
                    let codigo = this.nro_lote.charAt(1);
                    let ant = this.obtener_antioxidante(codigo);
                    this.ant = ant;
                    console.log('antioxidante',ant);
                }

                return this.ant ? this.ant.nombre : '';
            }
            return '';
        },
        tipo_lote(){
            if(this.nro_lote){
                if(this.nro_lote.includes("R")){
                    /**lote repaso */
                    let tp = this.obtener_tipo_lote('R');
                    this.tp = tp;
                    console.log('tipo lote',tp);
                }else{
                    /**lote normal */
                    let tp = this.obtener_tipo_lote('N');
                    this.tp = tp;
                    console.log('tipo lote',tp);
                }
                return this.tp ? this.tp.tipo_lote : '';
            }
            return '';
        },

        antioxidante_nombre_opciones(){
            if(this.ant){
                return this.antioxidante_nombres.filter(a=>a.antioxidantes_id == this.ant.id);
            }else{
                return [];
            }
        },

        validar(){
            if(this.mp != null && this.tp != null && this.ant != null && !this.regexTest(this.nro_lote) && this.nro_lote != ''){
                return true;
            }else{
                return false;
            }
        },

        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker,
    }
}
</script>
<style>
.hidden{
    display: none;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background: #d2d6d8 !important;
    color: #212121 !important;
}
</style>